import I18n from 'I18n';
import { Fragment, useMemo } from 'react';
import styled from 'styled-components';
import { AutoSizedTextInput } from 'foundations-components/transitional/components/AutoSizedTextInput';
import { Button } from 'foundations-components/transitional/components/Button';
import { DragHandle } from 'foundations-components/transitional/components/DragHandle';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TableHoverContent } from 'foundations-components/transitional/components/Table';
import OptionPreselect from 'ui-forms-components/options/OptionPreselect';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledContainer = styled.div.withConfig({
  displayName: "OptionsTableRow__StyledContainer"
})(["opacity:", ";"], ({
  isDragging
}) => isDragging ? 0.3 : 1);
const OptionsLabel = ({
  id,
  label,
  updateLabel,
  inputClass
}) => /*#__PURE__*/_jsx(AutoSizedTextInput, {
  id: id,
  "data-test-id": "options-table-text-input",
  affordance: true,
  defaultValue: label,
  onBlur: e => updateLabel(e),
  onChange: updateLabel,
  inputClassName: inputClass,
  placeholder: I18n.text('options.editLabel')
}, id);
const OptionsTableRow = ({
  id = '',
  label = '',
  value = '',
  fieldType = '',
  selectedOptions = [],
  truncateText = false,
  showEditActions = true,
  showInternalValue = true,
  showPreselect = true,
  showDrag = true,
  onRemove = () => {},
  renderCustomInternalValueColumn,
  updateLabel = () => {},
  updatePreselected = () => {},
  labelWidth = '300px',
  isDragging = false
}) => {
  const inputClass = useMemo(() => truncateText ? 'truncate-text' : '', [truncateText]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showPreselect && /*#__PURE__*/_jsx(DragHandle, {
      children: /*#__PURE__*/_jsx("td", {
        "data-test-id": "options-table-preselect-drag-handle",
        style: {
          width: labelWidth
        },
        children: /*#__PURE__*/_jsx(StyledContainer, {
          isDragging: isDragging,
          children: /*#__PURE__*/_jsx(OptionPreselect, {
            "data-test-id": "options-table-preselect",
            value: value,
            fieldType: fieldType,
            selectedOptions: selectedOptions,
            handlePreselect: updatePreselected,
            children: /*#__PURE__*/_jsx(OptionsLabel, {
              id: id,
              label: label,
              updateLabel: updateLabel,
              inputClass: inputClass
            })
          })
        })
      })
    }), !showPreselect && showDrag && /*#__PURE__*/_jsx(DragHandle, {
      children: /*#__PURE__*/_jsx("td", {
        "data-test-id": "options-table-no-preselect-drag-handle",
        children: /*#__PURE__*/_jsx(StyledContainer, {
          isDragging: isDragging,
          children: "\xA0"
        })
      })
    }), showEditActions && /*#__PURE__*/_jsxs(Fragment, {
      children: [!showPreselect && /*#__PURE__*/_jsx(OptionsLabel, {
        id: id,
        label: label,
        updateLabel: updateLabel,
        inputClass: inputClass
      }), renderCustomInternalValueColumn ? renderCustomInternalValueColumn(value) : showInternalValue && /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(StyledContainer, {
          isDragging: isDragging,
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: value
          })
        })
      }), /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(StyledContainer, {
          isDragging: isDragging,
          children: /*#__PURE__*/_jsx(TableHoverContent, {
            children: /*#__PURE__*/_jsx(Button, {
              onClick: onRemove,
              size: "extra-small",
              use: "tertiary-light",
              "data-test-id": "options-table-remove-option",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "options.remove"
              })
            })
          })
        })
      })]
    }), !showEditActions && /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(StyledContainer, {
        isDragging: isDragging,
        children: /*#__PURE__*/_jsx(Text, {
          margin: "0",
          marginInlineStart: "400",
          children: label
        })
      })
    })]
  });
};
export default OptionsTableRow;